import * as React from 'react';

import { Box, Paper, Typography } from '@mui/material';
import { unstable_useId as useId } from '@mui/material/utils';

import styles from './FormSection.module.css';

export interface FormSectionProps {
  title: string;
  description?: React.ReactNode;
  /** Rendered at the top right, e.g. a secondary action button. */
  action?: React.ReactNode;
  children: React.ReactNode;
}

/** A titled, outlined block that groups related fields within a step. */
const FormSection: React.FC<FormSectionProps> = ({
  title,
  description,
  action,
  children,
}) => {
  const headingId = useId();
  return (
    <Paper
      variant="outlined"
      component="section"
      aria-labelledby={headingId}
      className={styles.section}
    >
      <Box className={styles.header}>
        <Box>
          <Typography id={headingId} variant="subtitle1" component="h3" fontWeight={600}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Box>
        {action && <Box className={styles.action}>{action}</Box>}
      </Box>
      <Box className={styles.body}>{children}</Box>
    </Paper>
  );
};

export default FormSection;
